import * as React from 'react';
import { Button, Col, Form, Row, DropdownButton, Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import {
    getAllMedium, getAllSubjectcategory, getSubjectCategoryDecipline, getSubjectbyCourseAndDiscipline,
    getCourseCreditPreference, postSubjectPreference
} from "../../api/studentDetails";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MinorSubject({ courseId, majorSubjects = [], existingPreferences }) {
    console.log("selected course for minnor group-", courseId)
    const [medium, setMedium] = useState([]);
    const [subjectCategories, setSubjectCategories] = useState([]);
    const [selectedMedium, setselectedMedium] = useState("");
    const [selectedSubjectCategory, setSelectedSubjectCategory] = useState("");
    const [discipline, setDiscipline] = useState([]);
    const [selectedDiscipline, setSelectedDiscipline] = useState(null);
    const [subjects, setSubjects] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [addedSubjects, setAddedSubjects] = useState([]);
    const [error, setError] = useState('');
    const [minCredit, setMinCredit] = useState(null);
    const [maxCredit, setMaxCredit] = useState(null);
    const [creditRange, setCreditRange] = useState({ min: 0, max: 0 });
    const [maxPreference, setMaxPreference] = useState(0);
    const [selectedDisciplines, setSelectedDisciplines] = useState([]);
    const [selectedMajorGroup, setSelectedMajorGroup] = useState(null);
    const [majorGroupPreferences, setMajorGroupPreferences] = useState({});
    const [subjectCategoryPreference, setSubjectCategoryPreference] = useState({});
    const [errors, setErrors] = useState({});
    const [creditsPerCategoryAndGroup, setCreditsPerCategoryAndGroup] = useState({});
    const [studentSubjectPreference, setStudentSubjectPreference] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    const studentId = typeof window !== "undefined" ? localStorage.getItem("id") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const mediumResponse = await getAllMedium(token);
                const mediumData = mediumResponse.data;
                setMedium(mediumData);

                const englishMedium = mediumData.find((m) => m.mediumDescription.toLowerCase() === "english");
                if (englishMedium) {
                    setselectedMedium(englishMedium.id);
                }
                const subjectCategoryResponse = await getAllSubjectcategory(token);
                const categoryData = subjectCategoryResponse.data;
                const filteredCategories = categoryData.filter(category => !category.checkIfMajor);
                setSubjectCategories(filteredCategories);
            } catch (error) {
                setError('Error fetching data: ' + (error.response?.data?.message || error.message));
            }
        };
        fetchInitialData();
    }, [token]);


    useEffect(() => {
        const fetchCreditPreference = async () => {
            if (!selectedSubjectCategory) return;
            console.log("selcted subject category=", selectedSubjectCategory)
            try {
                const response = await getCourseCreditPreference(token, selectedSubjectCategory, courseId);
                console.log("getCourseCreditPreference for selected subject categpry=", response.data)
                const { minCredits, maxCredits } = response.data;
                console.log("Min Max credits =", minCredits, maxCredits)
                setMinCredit(minCredits);
                setMaxCredit(maxCredits);
            } catch (error) {
                console.error("Error fetching credit range:", error.response || error.message);
            }
        };
        fetchCreditPreference();
    }, [token, selectedSubjectCategory]);


    useEffect(() => {
        if (existingPreferences) {
            console.log("Processing existing preferences:", existingPreferences);

            const transformedSubjects = [];


            if (existingPreferences.majorDisciplines?.length > 0) {
                existingPreferences.majorDisciplines.forEach(major => {
                    transformedSubjects.push({
                        subpreference: 1,
                        subjectCategory: "MAJOR",
                        discipline: major.majorDiscipline.disciplineName,
                        subjectName: "Major Subject Group",
                        disciplineIds: major.majorDiscipline.id,
                        subjectIds: [],
                        subjectCategoryIds: major.id,
                        preference: major.preferenceNo
                    });
                });
            }


            if (existingPreferences.otherSubjectCategories?.length > 0) {
                existingPreferences.otherSubjectCategories.forEach((subject, index) => {
                    transformedSubjects.push({
                        subpreference: index + 1,
                        subjectCategory: subject.subjectCategory?.subjectCategoryName || "N/A",
                        discipline: subject.discipline?.disciplineName || "N/A",
                        subjectName: subject.subjectDefinition?.subjectName || "N/A",
                        disciplineIds: subject.discipline?.id || "",
                        subjectIds: [subject.subjectDefinition?.id] || [],
                        subjectCategoryIds: subject.subjectCategory?.id || "",
                        preference: subject.majorDisciplinePreferenceId || 1
                    });
                });
            }

            console.log("Transformed subjects:", transformedSubjects);
            setAddedSubjects(transformedSubjects);

            if (transformedSubjects.length > 0) {
                const firstSubject = transformedSubjects[0];
            }
        }
    }, [existingPreferences]);

    useEffect(() => {
        const fetchDiscipline = async () => {
            if (!selectedSubjectCategory || !courseId) return;

            try {
                const response = await getSubjectCategoryDecipline(token, selectedSubjectCategory);

                const filteredDisciplines = response.data.filter(d => {
                    const matchesCategory = Number(d.subjectCategory?.id) === Number(selectedSubjectCategory);
                    const matchesCourse = Number(d.course?.id) === Number(courseId);

                    console.log(`Discipline ${d.id}:`, {
                        disciplineCourse: d.course?.id,
                        selectedCourse: courseId,
                        matchesCourse,
                        subjectCategory: d.subjectCategory?.id,
                        selectedCategory: selectedSubjectCategory,
                        matchesCategory
                    });

                    return matchesCategory && matchesCourse;
                });


                setDiscipline(filteredDisciplines);


                const maxPref = filteredDisciplines.length > 0
                    ? Math.max(...filteredDisciplines.map(d => d.maxPreference || 0))
                    : 0;
                setMaxPreference(maxPref);

            } catch (error) {

                setError('Error fetching disciplines: ' + (error.response?.data?.message || error.message));
            }
        };
        fetchDiscipline();
    }, [token, selectedSubjectCategory, courseId]);

    useEffect(() => {
        if (discipline.length > 0) {
            const maxPref = Math.max(...discipline.map(d => d.maxPreference), 0);
            setMaxPreference(maxPref);
        }
    }, [discipline]);

    useEffect(() => {
        const fetchSubjectbyCourseAndDiscipline = async () => {
            if (!selectedDiscipline || !courseId || !selectedSubjectCategory) {

                return;
            }

            try {
                const response = await getSubjectbyCourseAndDiscipline(
                    token,
                    Number(courseId),
                    Number(selectedDiscipline.discipline.id)
                );
                const filteredSubjects = response.data.filter(subject =>
                    Number(subject.subjectCategory?.id) === Number(selectedSubjectCategory)
                );


                const preSelected = filteredSubjects
                    .filter(subject => !subject.elective)
                    .map(subject => subject.id);



                setSelectedSubjects(preSelected);
                setSubjects(filteredSubjects);

            } catch (error) {
                setError('Error fetching subjects: ' + (error.response?.data?.message || error.message));
            }
        };
        fetchSubjectbyCourseAndDiscipline();
    }, [token, courseId, selectedDiscipline, selectedSubjectCategory]);

    const handleCheckboxChange = (e) => {
        const subjectId = parseInt(e.target.value);
        const subject = subjects.find(sub => sub.id === subjectId);
        if (!subject) return;
        const subjectCredits = subject.subjectDefinition.credits;
        setSelectedSubjects((prevSelected) => {
            let newSelected;
            if (prevSelected.includes(subjectId)) {
                newSelected = prevSelected.filter((id) => id !== subjectId);
            } else {
                newSelected = [...prevSelected, subjectId];
            }

            const totalCredits = newSelected.reduce((acc, id) => {
                const sub = subjects.find(s => s.id === id);
                return acc + (sub ? sub.subjectDefinition.credits : 0);
            }, 0);

            if (totalCredits < creditRange.min || totalCredits > creditRange.max) {
                setError(`Total credits must be between ${creditRange.min} and ${creditRange.max}. Currently selected: ${totalCredits}`);
                toast.error(`Total credits must be between ${creditRange.min} and ${creditRange.max}. Currently selected: ${totalCredits}`);
                return prevSelected;
            } else {
                setError("");
            }

            return newSelected;
        });
        setErrors((prev) => ({ ...prev, subjects: "" }));
    };

    const handleMajorGroupChange = (e) => {
        const selectedMajorGroup = e.target.value;
        setSelectedMajorGroup(selectedMajorGroup);

        const majorGroup = majorSubjects.find(major => major.preference === selectedMajorGroup);
        if (majorGroup) {
            setMajorGroupPreferences((prev) => ({
                ...prev,
                [selectedMajorGroup]: majorGroup.maxPreference,
            }));
        }
        setErrors((prev) => ({ ...prev, selectedMajorGroup: "", subjects: "" }));
    };

    const handleSubjectCategoryChange = (e) => {
        const selectedSubjectCategory = e.target.value;
        setSelectedSubjectCategory(selectedSubjectCategory);

        const subjectCategory = subjectCategories.find(category => category.id === selectedSubjectCategory);
        if (subjectCategory) {
            setSubjectCategoryPreference((prev) => ({
                ...prev,
                [selectedSubjectCategory]: subjectCategory.maxPreference,
            }));
        }
        setErrors((prev) => ({ ...prev, selectedSubjectCategory: "", subjects: "" }));
    };

    const handleDisciplineChange = (e) => {
        const selectedId = parseInt(e.target.value);
        const selected = discipline.find(d => d.id === selectedId);

        if (!selected) return;

        const currentSelectedForCategory = selectedDisciplines[selectedSubjectCategory] || {};
        const currentSelectedForMajorGroup = currentSelectedForCategory[selectedMajorGroup] || [];

        setSelectedDisciplines((prev) => ({
            ...prev,
            [selectedSubjectCategory]: {
                ...prev[selectedSubjectCategory],
                [selectedMajorGroup]: [...currentSelectedForMajorGroup, selected],
            },
        }));

        setSelectedDiscipline(selected);
        setCreditRange({ min: minCredit, max: maxCredit });
        setErrors((prev) => ({ ...prev, selectedDiscipline: "", subjects: "" }));
    };

    const handleAddSubjects = () => {

        if (selectedSubjects.length === 0) {
            setErrors({ subjects: "Please select at least one subject." });
            return false;
        }

        const selectedCredits = selectedSubjects.reduce((total, subjectId) => {
            const subject = subjects.find(s => s.id === subjectId);
            return total + (subject ? subject.subjectDefinition.credits : 0);
        }, 0);

        const currentCredits = creditsPerCategoryAndGroup[`${selectedSubjectCategory}-${selectedMajorGroup}`] || 0;
        const newTotalCredits = currentCredits + selectedCredits;

        if (newTotalCredits > maxCredit) {
            toast.error(`Cannot add these subjects. Total credits for this category and major group would exceed the maximum of ${maxCredit}.`);
            return;
        }

        const majorGroup = majorSubjects.find(major => Number(major.preference) === Number(selectedMajorGroup));

        const newSubjects = selectedSubjects.map(subjectId => {
            const subject = subjects.find(s => s.id === subjectId);
            return {
                id: subjectId,
                subjectCategory: subjectCategories.find(c => c.id == selectedSubjectCategory)?.subjectCategoryName || "",
                discipline: selectedDiscipline.discipline.disciplineName || "",
                subjectName: subject.subjectDefinition.subjectName || "",
                subpreference: addedSubjects.length + 1,
                disciplineId: selectedDiscipline.discipline.id || "",
                subjectId: subject.subjectDefinition.id || "",
                subjectCategoryId: subjectCategories.find(c => c.id == selectedSubjectCategory)?.id || "",
                preference: majorGroup ? majorGroup.preference : "",
                majorDisciplines: majorGroup ? majorGroup.selectedMajorGroupId : "",
                majorCategories: majorGroup ? majorGroup.subjectCategories : "",
                majorSubjects: majorGroup ? majorGroup.selectedSubjects : "",
            };
        });

        const concatenatedSubjectNames = newSubjects.map(subject => subject.subjectName).join(", ");
        const subjectDefinitionIds = newSubjects.map(subject => subject.subjectId);
        setAddedSubjects(prevSubjects => [
            ...prevSubjects,
            {
                subpreference: addedSubjects.length + 1,
                subjectCategory: newSubjects[0].subjectCategory,
                discipline: newSubjects[0].discipline,
                subjectName: concatenatedSubjectNames,
                disciplineIds: newSubjects[0].disciplineId,
                subjectIds: subjectDefinitionIds,
                subjectCategoryIds: newSubjects[0].subjectCategoryId,
                preference: newSubjects[0].preference,
                majorDisciplines: newSubjects[0].majorDisciplines,
                majorCategories: newSubjects[0].majorCategories,
                majorSubjects: newSubjects[0].majorSubjects
            }
        ]);
        setCreditsPerCategoryAndGroup(prev => ({
            ...prev,
            [`${selectedSubjectCategory}-${selectedMajorGroup}`]:
                (prev[`${selectedSubjectCategory}-${selectedMajorGroup}`] || 0) + selectedCredits
        }));
        setSelectedSubjects([]);
    };

    const handleDeleteRow = (index) => {
        const subjectToDelete = addedSubjects[index];
        setAddedSubjects(prevData => prevData.filter((_, i) => i !== index));
        setCreditsPerCategoryAndGroup(prev => ({
            ...prev,
            [`${subjectToDelete.subjectCategoryIds}-${subjectToDelete.preference}`]:
                (prev[`${subjectToDelete.subjectCategoryIds}-${subjectToDelete.preference}`] || 0) - subjectToDelete.credits
        }));
    };

    const handleSavePreferences = async () => {
        if (isSubmitting) return; // Prevent multiple submissions

        setIsSubmitting(true);
        setError('');

        // Validation
        const newErrors = {};
        if (!selectedMedium) {
            newErrors.selectedMedium = "Medium is Required.";
        }
        if (!selectedMajorGroup && majorSubjects.length > 0) {
            newErrors.selectedMajorGroup = "Major Group is Required.";
        }
        if (!selectedSubjectCategory) {
            newErrors.selectedSubjectCategory = "Subject Category is Required.";
        }
        if (!selectedDiscipline) {
            newErrors.selectedDiscipline = "Discipline is Required.";
        }
        if (addedSubjects.length === 0) {
            newErrors.addedSubjects = "Please add at least one subject before saving.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitting(false);
            toast.error("Please fill all required fields and add subjects.");
            return;
        }

         try {
            console.log("Preparing to save preferences...");
            
            // Build the request body according to your API expectations
            const requestBody = buildRequestBody();
            
            console.log("Final Request Body:", JSON.stringify(requestBody, null, 2));

            // Validate request body
            if (!isRequestBodyValid(requestBody)) {
                throw new Error("Invalid request data structure");
            }

            const response = await postSubjectPreference(token, requestBody, studentId, courseId);
            
            console.log("API Response:", response);
            
            if (response && response.data) {
                toast.success("Preferences saved successfully!");
                // Optional: Reset form or redirect
            } else {
                throw new Error("Invalid response from server");
            }
            
        } catch (error) {
            console.error("Error saving preferences:", error);
            
            let errorMessage = "Error saving preferences.";
            
            if (error.response) {
                // Server responded with error status
                console.error("Server response error:", error.response.data);
                errorMessage = error.response.data.message || `Server error: ${error.response.status}`;
            } else if (error.request) {
                // Request was made but no response received
                console.error("No response received:", error.request);
                errorMessage = "No response from server. Please check your connection.";
            } else {
                // Something else happened
                errorMessage = error.message || "Unknown error occurred.";
            }
            
            toast.error(errorMessage);
            setError(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };
// Helper function to build request body
    const buildRequestBody = () => {
        // Group by major discipline preference
        const groupedByMajor = addedSubjects.reduce((acc, subject) => {
            const majorKey = subject.preference || '1'; // Default to 1 if no preference
            
            if (!acc[majorKey]) {
                acc[majorKey] = {
                    majorDisciplineId: subject.majorDisciplines,
                    preferenceNo: parseInt(subject.preference) || 1,
                    majorSubjectCategoryId: subject.majorCategories,
                    subjectDefinitionIds: Array.isArray(subject.majorSubjects) ? subject.majorSubjects : [],
                    otherSubjectCategories: []
                };
            }

            // Add minor subject details
            const minorSubject = {
                subjectCategoryId: parseInt(subject.subjectCategoryIds),
                disciplineId: parseInt(subject.disciplineIds),
                subjectDefinitionIds: Array.isArray(subject.subjectIds) ? subject.subjectIds : [subject.subjectIds].filter(Boolean)
            };

            // Only add if we have valid IDs
            if (minorSubject.subjectCategoryId && minorSubject.disciplineId && minorSubject.subjectDefinitionIds.length > 0) {
                acc[majorKey].otherSubjectCategories.push(minorSubject);
            }

            return acc;
        }, {});

        // Convert to array and filter out empty entries
        const majorDisciplines = Object.values(groupedByMajor).filter(major => 
            major.majorDisciplineId && 
            major.otherSubjectCategories.length > 0
        );

        return { majorDisciplines };
    };

    // Helper function to validate request body
    const isRequestBodyValid = (requestBody) => {
        if (!requestBody.majorDisciplines || !Array.isArray(requestBody.majorDisciplines)) {
            return false;
        }

        return requestBody.majorDisciplines.every(major => 
            major.majorDisciplineId &&
            major.preferenceNo &&
            Array.isArray(major.otherSubjectCategories) &&
            major.otherSubjectCategories.every(minor =>
                minor.subjectCategoryId &&
                minor.disciplineId &&
                Array.isArray(minor.subjectDefinitionIds) &&
                minor.subjectDefinitionIds.length > 0
            )
        );
    };
    return (
        <>
            <hr style={{ marginTop: "0px", background: "#6e48aa" }}></hr>
            <Form>
                <Row>
                    <Col>
                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Medium / Instruction Medium<span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    name="medium"
                                    value={selectedMedium}
                                    onChange={(e) => setselectedMedium(e.target.value)}
                                >
                                    <option>Select Medium</option>
                                    {medium.map((data) => (
                                        <option key={data.id} value={data.id}>
                                            {data.mediumDescription}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.selectedMedium && (
                                    <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                        {errors.selectedMedium}
                                    </div>
                                )}
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Major Group<span className="text-danger">*</span></Form.Label>
                                <Form.Select name="majorgroup"
                                    value={selectedMajorGroup}
                                    onChange={handleMajorGroupChange}>
                                    <option>Select Major Group</option>
                                    {majorSubjects.length > 0 ? (
                                        majorSubjects.map((major, index) => (
                                            <option key={index} value={major.preference}>
                                                {major.major} (Preference {major.preference})
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>No major subjects available</option>
                                    )}
                                </Form.Select>
                                {errors.selectedMajorGroup && (
                                    <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                        {errors.selectedMajorGroup}
                                    </div>
                                )}
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Subject Category<span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    name="subjectcategory"
                                    value={selectedSubjectCategory}
                                    onChange={handleSubjectCategoryChange} >
                                    <option>Select Subject Category</option>
                                    {subjectCategories.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.subjectCategoryName}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.selectedSubjectCategory && (
                                    <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                        {errors.selectedSubjectCategory}
                                    </div>
                                )}
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Discipline<span className="text-danger">*</span></Form.Label>
                                <Form.Select name="discipline"
                                    value={selectedDiscipline ? selectedDiscipline.id : ""}
                                    onChange={handleDisciplineChange}
                                >
                                    <option>Select Discipline</option>
                                    {discipline.map((data) => (
                                        <option key={data.id} value={data.id}>
                                            {data.discipline.disciplineName}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.selectedDiscipline && (
                                    <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                        {errors.selectedDiscipline}
                                    </div>
                                )}
                            </Form.Group>
                            <ToastContainer />
                        </Row>
                    </Col>

                    <Col>
                        {selectedDiscipline && (
                            <Row>
                                <Form.Label>  {subjectCategories.find(category => category.id == selectedSubjectCategory)?.subjectCategoryName || "Select a Subject Category"}
                                    {minCredit !== null && maxCredit !== null && (
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "#f00", marginLeft: "10px" }}>
                                            Credit Range: Min {minCredit} - Max {maxCredit}
                                        </span>
                                    )}
                                </Form.Label>

                                <DropdownButton
                                    title={`All Selected Subjects (${selectedSubjects.length})`}
                                    id="course-dropdown"
                                    className="course-dropdown"
                                >
                                    <div style={{ padding: '10px' }}>
                                        {subjects.map((subject) => (
                                            <div key={subject.id}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`subject-${subject.id}`}
                                                    value={subject.id}
                                                    label={`${subject.subjectDefinition.subjectName} (CR: ${subject.subjectDefinition.credits})`}
                                                    checked={!subject.elective || selectedSubjects.includes(subject.id)}
                                                    disabled={!subject.elective}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <small className="text-muted">
                                                    Category: {subject.subjectCategory?.subjectCategoryName} (ID: {subject.subjectCategory?.id})
                                                </small>
                                            </div>
                                        ))}
                                    </div>
                                </DropdownButton>
                                {errors.subjects && (
                                    <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                        {errors.subjects}
                                    </div>
                                )}
                                <Col className="mt-2 d-flex align-items-center justify-content-center">
                                    <Button variant="secondary" type="button" onClick={handleAddSubjects}>
                                        Add
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                        <Button variant="primary" type="button" onClick={handleSavePreferences}>
                                                  {isSubmitting ? 'Saving...' : 'Save Preferences'}

                        </Button>
                    </Col>
                </Row>
            </Form>
            <Row>
                <b>Subject Group</b>
                <Table responsive striped bordered hover>
                    <thead style={{
                        backgroundColor: "#6e48aa",
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "600",
                    }}>
                        <tr>
                            <th style={{ width: "10%" }}> Sub Preference </th>
                            <th style={{ width: "10%" }}>  Preference </th>
                            <th style={{ width: "20%" }}>subject Category</th>
                            <th style={{ width: "20%" }}>Discipline</th>
                            <th>Subject </th>
                            <th style={{ width: "10%", textAlign: "center" }}>Action </th>
                        </tr>
                    </thead>
                    <tbody>
                        {addedSubjects.map((subject, index) => (
                            <tr key={index}>
                                <td>{subject.subpreference}</td>
                                <td>{subject.preference}</td>
                                <td>{subject.subjectCategory}</td>
                                <td>{subject.discipline}</td>
                                <td>{subject.subjectName}</td>
                                <td style={{ textAlign: "center" }}>
                                    <DeleteSweepIcon style={{ color: "#f00" }}
                                        onClick={() => handleDeleteRow(index)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </Table>
            </Row>
        </>
    );
};

export default MinorSubject;